import React, {PureComponent, Fragment} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import moment from 'moment';
import Field from '../../Field';
import TextInput from '../../TextInput';
import DateInput from '../../DateInput';
import CheckboxInput from '../../CheckboxInput';
import GenderInput from '../../GenderInput';
import GroupInput from '../../GroupInput';
import PhoneInput from '../../PhoneInput';
import {validators, validate} from '../../../validation';
import './ContactForm.less';


export default class ContactForm extends PureComponent {
  static propTypes = {
    setFirstName: PropTypes.func,
    setLastName: PropTypes.func,
    setEmailAddress: PropTypes.func,
    setMobilePhone: PropTypes.func,
    setDateOfBirth: PropTypes.func,
    setGender: PropTypes.func,
    setMaritalStatus: PropTypes.func,
    First_Name: PropTypes.string,
    Last_Name: PropTypes.string,
    Email_Address: PropTypes.string,
    Mobile_Phone: PropTypes.string,
    Date_of_Birth: PropTypes.string,
    Group_ID: PropTypes.number,
    Gender_ID: PropTypes.number,
    Marital_Status_ID: PropTypes.number,

    setFirstNameErrors: PropTypes.func,
    setLastNameErrors: PropTypes.func,
    setEmailAddressErrors: PropTypes.func,
    setMobilePhoneErrors: PropTypes.func,
    setDateOfBirthErrors: PropTypes.func,
    setGroupErrors: PropTypes.func,
    setGenderErrors: PropTypes.func,
    setMaritalStatusErrors: PropTypes.func,
    First_Name_Errors: PropTypes.arrayOf(PropTypes.string),
    Last_Name_Errors: PropTypes.arrayOf(PropTypes.string),
    Email_Address_Errors: PropTypes.arrayOf(PropTypes.string),
    Mobile_Phone_Errors: PropTypes.arrayOf(PropTypes.string),
    Date_of_Birth_Errors: PropTypes.arrayOf(PropTypes.string),
    Group_ID_Errors: PropTypes.arrayOf(PropTypes.string),
    Gender_ID_Errors: PropTypes.arrayOf(PropTypes.string),
    Marital_Status_ID_Errors: PropTypes.arrayOf(PropTypes.string),

    hideMaritalStatus: PropTypes.bool,
    hideGender: PropTypes.bool,
    hideDateOfBirth: PropTypes.bool,
    className: PropTypes.string,
    title: PropTypes.string
  };

  validators = {
    User_Name: [validators.required(), validators.username(), validators.length({min: 4, max: 100})]
  };

  render() {
    let {
      First_Name,
      Last_Name,
      Email_Address,
      Mobile_Phone,
      Date_of_Birth,
      Group_ID,
      Gender_ID,
      Marital_Status_ID,
      User_Name,
      Password,
      Guest,
      setFirstName,
      setLastName,
      setEmailAddress,
      setMobilePhone,
      setDateOfBirth,
      setGroup,
      setGender,
      setGuest,
      setMaritalStatus,
      setUserName,
      setPassword,

      First_Name_Errors,
      Last_Name_Errors,
      Email_Address_Errors,
      Mobile_Phone_Errors,
      Date_of_Birth_Errors,
      Group_ID_Errors,
      Gender_ID_Errors,
      Marital_Status_ID_Errors,
      User_Name_Errors,
      Password_Errors,
      Guest_Errors,
      setFirstNameErrors,
      setLastNameErrors,
      setEmailAddressErrors,
      setMobilePhoneErrors,
      setDateOfBirthErrors,
      setGroupErrors,
      setGenderErrors,
      setGuestErrors,
      setMaritalStatusErrors,
      setUserNameErrors,
      setPasswordErrors,

      hideMaritalStatus = false,
      hideGender = false,
      hideEmailAddress = false,
      hideMobilePhone = false,
      hideDateOfBirth = false,
      showUserFields = false,
      className,
      title,
      showGuest = false
    } = this.props;

    const eighteenYearsAgo = moment().subtract(18, 'years');

    return (
      <div className={cx("contact-form", className)}>
        <h3>{title}</h3>
        <Field label="First" value={First_Name} onChange={setFirstName}
            validators={[validators.required()]}
            errors={First_Name_Errors}
            setErrors={setFirstNameErrors}>
          <TextInput />
        </Field>
        <Field label="Last" value={Last_Name} onChange={setLastName}
            validators={[validators.required()]}
            errors={Last_Name_Errors}
            setErrors={setLastNameErrors}>
          <TextInput />
        </Field>
        {!hideEmailAddress && <Field label="Email" value={Email_Address} onChange={this._setEmailAddress}
            validators={[validators.required(), validators.email()]}
            errors={Email_Address_Errors}
            setErrors={setEmailAddressErrors}>
          <TextInput type="email" />
        </Field>}
        {!hideMobilePhone && <Field label="Cell" value={Mobile_Phone} onChange={setMobilePhone}
            validators={[validators.required(), validators.phone()]}
            errors={Mobile_Phone_Errors}
            setErrors={setMobilePhoneErrors}>
          <PhoneInput />
          {/*<TextInput type="tel" />*/}
        </Field>}
        {showUserFields &&
          <Fragment>
            <Field label="Username" value={User_Name} onChange={this._setUserName}
                validators={this.validators.User_Name}
                errors={User_Name_Errors}
                setErrors={setUserNameErrors}>
              <TextInput autoComplete="off" />
            </Field>
            <Field label="Password" value={Password} onChange={setPassword}
                validators={[validators.required(), validators.password()]}
                errors={Password_Errors}
                setErrors={setPasswordErrors}>
              <TextInput type="password" autoComplete="new-password" />
            </Field>
          </Fragment>
        }
        {!hideDateOfBirth && <Field label="D.O.B." value={Date_of_Birth && moment(Date_of_Birth)} onChange={setDateOfBirth}
            validators={[validators.required(), validators.momentObject()]}
            errors={Date_of_Birth_Errors}
            setErrors={setDateOfBirthErrors}>
          <DateInput />
        </Field>}
        {(!hideDateOfBirth && Date_of_Birth && moment(Date_of_Birth).isAfter(eighteenYearsAgo)) &&
          <Field label="Grade" value={Group_ID} onChange={setGroup}
              errors={Group_ID_Errors}
              setErrors={setGroupErrors}>
            <GroupInput />
          </Field>
        }
        {!hideGender && <Field label="Gen." value={Gender_ID} onChange={setGender}
            validators={[validators.required()]}
            errors={Gender_ID_Errors}
            setErrors={setGenderErrors}>
          <GenderInput />
        </Field>}
        {!hideMaritalStatus && <Field stacked
            label="Would you like to add information for your spouse?"
            value={Marital_Status_ID === 2}
            onChange={value => setMaritalStatus(value ? 2 : null)}
            errors={Marital_Status_ID_Errors}
            setErrors={setMaritalStatusErrors}>
          <CheckboxInput>Yes</CheckboxInput>
        </Field>}
        {showGuest &&
          <Field stacked
            label="Is this a guest?"
            value={Guest}
            onChange={setGuest}
            errors={Guest_Errors}
            setErrors={setGuestErrors}>
            <CheckboxInput>Yes</CheckboxInput>
          </Field>
        }
      </div>
    );
  }

  _setUserName = (value) => {
    this.props.setUserName(value);

    if (value && value.length >= 8) {
      fetch('https://planyourvisit-user.pathway.apps.blackpulp.com/api/v1/users/username_check', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          User_Name: value
        })
      })
      .then(response => {
        if (value === this.props.User_Name) {
          if (response.status === 406) {
            response.json().then(({errors}) => {
              this.props.setUserNameErrors(errors.User_Name);
            });
          }
        }
      });
    }
  };

  _setEmailAddress = (value) => {
    const {showUserFields, User_Name, setUserName, setUserNameErrors, setEmailAddress} = this.props;

    setEmailAddress(value);

    if (showUserFields) {
      if (!User_Name || value.startsWith(User_Name) || User_Name.startsWith(value)) {
        this._setUserName(value);
        setUserNameErrors(validate(value, this.validators.User_Name));
      }
    }
  };
}


// WEBPACK FOOTER //
// ./src/components/form-route/forms/ContactForm.js